import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { formatValidationErrors } from '../../common/utils/getApiReducer';
import { deleteEpisode, editEpisode, fetchTvShows, fetchTvEpisodes, getEpisodeVideo, uploadVideo } from '../actions';
import { selectActiveEpisode, selectActiveShow } from '../selectors';

import TvEpisodeEditForm from './TvEpisodeEditForm';
import Breadcrumb from '../../common/components/Breadcrumb';
import dataUrlToFile from '../../common/utils/dataUrlToFile';
import Loading from '../../common/components/Loading';

class TvEpisodeEditPage extends Component {
  static propTypes = {
    activeShow: PropTypes.object,
    activeEpisode: PropTypes.object,
    dispatch: PropTypes.func,
    episodes: PropTypes.object,
    initialValues: PropTypes.object,
  };

  state = {
    clearOrigImage: false,
  };

  componentDidMount() {
    if (!this.props.shows.get('loaded') && !this.props.shows.get('loading')) {
      this.props.dispatch(fetchTvShows());
    }

    if (!this.props.episodes.get('loaded') && !this.props.episodes.get('loading')) {
      this.props.dispatch(fetchTvEpisodes(this.props.match.params.showId));
    } else {
      if (this.props.activeEpisode.get('video_id')) {
        this.props
          .dispatch(getEpisodeVideo(this.props.match.params.showId, this.props.match.params.id))
          .then(this.handleVideoResponse);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.activeShow &&
      (!this.props.activeShow || this.props.activeShow.get('id') !== nextProps.activeShow.get('id'))
    ) {
      this.props.dispatch(fetchTvEpisodes(nextProps.activeShow.get('id')));
    }

    if (!this.props.episodes.get('loaded') && nextProps.episodes.get('loaded')) {
      if (nextProps.activeEpisode.get('video_id')) {
        this.props
          .dispatch(getEpisodeVideo(nextProps.match.params.showId, nextProps.match.params.id))
          .then(this.handleVideoResponse);
      }
    }
  }

  onSubmit = values => {
    const { activeEpisode, dispatch, match: { params: { id, showId } } } = this.props;
    const { clearOrigImage } = this.state;

    if (values.image) {
      values.image = dataUrlToFile(values.image.imageResult, values.image.imageFilename);
    }

    if (!clearOrigImage) {
      values.image_id = activeEpisode.get('image_id');
    }

    return dispatch(editEpisode(showId, id, values)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.props.history.push(`/tv/shows/${showId}`);
      }
    });
  };

  onCancel = () => {
    this.props.history.push(`/tv/shows/${this.props.activeShow.get('id')}`);
  };

  onDelete = () => {
    const { dispatch, match: { params: { id, showId } } } = this.props;

    return dispatch(deleteEpisode(showId, id)).then(() => {
      this.props.history.push(`/tv/shows/${showId}`);
    });
  };

  checkVideoStatus = () => {
    const { dispatch, match: { params: { id, showId } } } = this.props;

    dispatch(getEpisodeVideo(showId, id)).then(this.handleVideoResponse);
  };

  handleVideoResponse = response => {
    if (response.json && response.json.transcode_status !== 'Complete' && response.json.transcode_status !== 'Error') {
      setTimeout(this.checkVideoStatus, 10000);
    }
  };

  onVideoUpload = file => {
    const { dispatch, match: { params: { id, showId } } } = this.props;

    return dispatch(uploadVideo(showId, id, file[0])).then(response => {
      setTimeout(this.checkVideoStatus, 10000);
    });
  };

  removeImage = () => {
    this.setState(state => ({
      clearOrigImage: true,
    }));
  };

  render() {
    const {
      activeShow,
      activeEpisode,
      episodes,
      episodeUploading,
      episodeUploadProgress,
      initialValues,
      shows,
    } = this.props;

    const { clearOrigImage } = this.state;

    if (!shows.get('loaded') || !episodes.get('loaded') || !activeShow || !activeEpisode) {
      return <Loading />;
    }

    const breadcrumbs = [
      {
        label: 'Tathata TV',
        to: '/tv/shows',
      },
      {
        label: activeShow.get('name'),
        to: `/tv/shows/${activeShow.get('id')}`,
      },
      {
        label: activeEpisode.get('name'),
        to: null,
      },
    ];

    return (
      <div className="admin-paper">
        <div className="admin-paper__header">
          <Breadcrumb crumbs={breadcrumbs} />
        </div>
        <TvEpisodeEditForm
          clearOrigImage={clearOrigImage}
          episode={activeEpisode}
          episodeUploading={episodeUploading}
          episodeUploadProgress={episodeUploadProgress}
          initialValues={initialValues}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
          onDelete={this.onDelete}
          onVideoUpload={this.onVideoUpload}
          removeImage={this.removeImage}
        />
      </div>
    );
  }
}

export default connect((state, ownProps) => {
  const activeShow = selectActiveShow(state, ownProps.match.params.showId);
  const activeEpisode = selectActiveEpisode(state, ownProps.match.params.id);

  return {
    activeShow,
    activeEpisode,
    episodes: state.tv.episodes,
    episodeUploading: state.tv.episodeUploading,
    episodeUploadProgress: state.tv.episodeUploadProgress,
    initialValues: activeEpisode
      ? {
          name: activeEpisode.get('name'),
          description: activeEpisode.get('description'),
          publish_at: activeEpisode.get('publish_at'),
        }
      : null,
    shows: state.tv.shows,
  };
})(TvEpisodeEditPage);



// WEBPACK FOOTER //
// ./src/tv/episodes/TvEpisodeEditPage.js